import type { PersonalizedPromptDescriptor } from '@bower/shared';

type PromptGenerationStorage = Pick<Storage, 'getItem' | 'setItem'>;

/**
 * Advance a persisted per-surface generation. The server owns selection; this
 * counter only asks it for the next deterministic dashboard set.
 */
export function nextPromptGeneration(storage: PromptGenerationStorage, key: string): number {
  const current = Number.parseInt(storage.getItem(key) ?? '0', 10);
  const next = Number.isSafeInteger(current) && current >= 0 ? current + 1 : 1;
  storage.setItem(key, String(next));
  return next;
}

export type PersonalizedPromptAnalyticsSource =
  | 'onboarding_ask'
  | 'dashboard_hero'
  | 'chat_empty_state';

export interface PersonalizedPromptAnalyticsProperties {
  readonly prompt_template_id: PersonalizedPromptDescriptor['analyticsTemplateId'];
  readonly prompt_category: PersonalizedPromptDescriptor['category'];
  readonly source: PersonalizedPromptAnalyticsSource;
  readonly position: number;
}

/**
 * The complete analytics contract for a displayed prompt suggestion. Keep this
 * intentionally closed: descriptor keys, text, and origin labels may contain
 * user data and must never leave the product through analytics.
 */
export function personalizedPromptAnalyticsProperties(
  prompt: PersonalizedPromptDescriptor,
  source: PersonalizedPromptAnalyticsSource,
  position: number,
): PersonalizedPromptAnalyticsProperties {
  return {
    prompt_template_id: prompt.analyticsTemplateId,
    prompt_category: prompt.category,
    source,
    position,
  };
}
